// True on a phone-sized screen (760px wide or less). The shell swaps the
// sidebar for a slide-out menu there, and index.css stacks page grids into
// one column under the same width, so both change together.
import { useSyncExternalStore } from "react";

export const PHONE_QUERY = "(max-width: 760px)";

function subscribe(cb: () => void): () => void {
  if (typeof window === "undefined" || !window.matchMedia) return () => {};
  const mq = window.matchMedia(PHONE_QUERY);
  mq.addEventListener("change", cb);
  return () => mq.removeEventListener("change", cb);
}

const snapshot = (): boolean => typeof window !== "undefined" && !!window.matchMedia && window.matchMedia(PHONE_QUERY).matches;

export function useIsPhone(): boolean {
  return useSyncExternalStore(subscribe, snapshot, () => false);
}
